
import { fetchSubscriptionApi } from "@/utils/subscription";
import { useQuery } from "@tanstack/react-query"


function useSub(isAuth) {
      const { data : subscriptionData, isLoading } = useQuery({
        queryKey: ['subscription'],
        queryFn: fetchSubscriptionApi,
        enabled : isAuth,
        cacheTime:60 * 60 * 1000,
        staleTime: 60 * 60 * 1000,
        retry: false
      })

      return {subscriptionData, isLoading}
}

export default useSub;
